<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <dashboard-filters
                    key="customer"
                    :roles="rolesOptions"
                    :officers="OfficerOptions"
                    :order-types="orderTypesOptions"
                    @select-officer="selectedOfficer = $event"
                    @select-role="selectedRole = $event"
                    @select-order-type="selectedType = $event"
                    @select-range="selectedRange = $event"
                    :filters="['officer', 'role', 'orderType', 'dataRange']"
                />
            </b-col>
        </b-row>
        <b-row class="mb-5 mt-5">
            <b-col md="6" class="mt-2">
                <h6>Summary</h6>
                <pie-chart :download="true" :data="summaryChart"></pie-chart>
            </b-col>
            <b-col md="6" class="mt-2">
                <h6>Value</h6>
                <column-chart
                    thousands=","
                    prefix="$"
                    :round="2"
                    :zeros="true"
                    xtitle="Officers"
                    ytitle="Value"
                    :data="valuePerOfficer"
                ></column-chart>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6" class="mt-2">
                <h6>Count</h6>
                <line-chart
                    xtitle="Months"
                    ytitle="Total"
                    :data="countPerMonth"
                ></line-chart>
            </b-col>

            <b-col md="6" class="mt-2">
                <h6>Duration</h6>
                <column-chart
                    xtitle="Months"
                    ytitle="Avg Hrs"
                    :data="avgDurations"
                ></column-chart>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import graphMixins from '@/mixins/graphMixins'

import DashboardFilters from '@/views/Dashboard/DashboardFilters'
export default {
    name: 'AnalyticsCharts',
    components: {
        DashboardFilters,
    },
    mixins: [graphMixins],

    data() {
        return {}
    },
    computed: {
        summaryChart() {
            const total = this.filteredOrders.length
            const completed = this.filteredOrders.filter(x => x.completed)
                .length
            return [
                ['Completed', completed],
                ['Incomplete', total - completed],
            ]
        },

        valuePerOfficer() {
            const $this = this
            return (this.officers || []).map(x => [
                x.name,
                $this.getOfficerValue(x.id),
            ])
        },

        countPerMonth() {
            const TotalData = {}
            const outstandingData = {}
            for (let x of this.lastSixMonths) {
                const mth = this.monthNames[x.month]
                const totalcnt = this.getMonthCount(x.month, x.year)
                const outstandCnt = this.monthIncomplete(x.month, x.year)
                TotalData[mth] = totalcnt
                outstandingData[mth] = outstandCnt
            }
            return [
                { name: 'Total', data: TotalData },
                { name: 'Outstanding', data: outstandingData },
            ]
        },

        avgDurations() {
            const avgCompletion = {}
            const overdueData = {}
            for (let x of this.lastSixMonths) {
                const mth = this.monthNames[x.month]
                const completionAmt = this.getMonthAvgDuration(x.month, x.year)
                const overdueAmt = this.getMonthAvgOverDue(x.month, x.year)
                avgCompletion[mth] = completionAmt
                overdueData[mth] = overdueAmt
            }
            return [
                { name: 'Avg Completion', data: avgCompletion },
                { name: 'Avg Overdue', data: overdueData },
            ]
        },
    },
    watch: {
        summaryChart: {
            handler: function (x) {
                console.log('summaryChart', x)
            },
            deep: true,
        },
    },
    methods: {
        getMonthCount(month, year) {
            const monthOrders = this.filteredOrders.filter(
                x => x.created_year === year && x.created_month === month
                //&& x.completed
            )
            return monthOrders.length
        },

        monthIncomplete(month, year) {
            const monthOrders = this.filteredOrders.filter(
                x =>
                    x.created_year === year &&
                    x.created_month === month &&
                    !x.completed
            )
            return monthOrders.length
        },

        getMonthAvgDuration(month, year) {
            const monthOrders = this.filteredOrders.filter(
                x =>
                    x.created_year === year &&
                    x.created_month === month &&
                    x.completed
            )
            const totalDuration = monthOrders.reduce((sum, order) => {
                sum += order.completedTime - order.createdTime
                return sum
            }, 0)
            return totalDuration / (monthOrders.length * 1000 * 60 * 60)
        },

        getMonthAvgOverDue(month, year) {
            const monthOrders = this.filteredOrders.filter(
                x =>
                    x.created_year === year &&
                    x.created_month === month &&
                    x.completed
            )
            const totalOverDue = monthOrders.reduce((sum, order) => {
                let overdue = order.completedTime - order.scheduleTime
                overdue = overdue > 0 ? overdue : 0
                sum += overdue
                return sum
            }, 0)
            return totalOverDue / (monthOrders.length * 1000 * 60 * 60)
        },

        getOfficerValue(id) {
            const officerOrders = this.filteredOrders.filter(
                x => x.officer_id === id
            )
            const totalValue = officerOrders.reduce((value, order) => {
                value += order.grand_total
                return value
            }, 0)
            return totalValue
        },
    },
}
</script>